const primaryNavItems = [
  {
    name: 'Categories',
    url: '#',
    key: 'categories',
    path: '/category',
  },
  {
    name: 'Brands',
    url: '#',
    key: 'brands',
    path: '/brand',
  },
  // {
  //   name: 'Installment Options',
  //   url: '/installment',
  //   key: 'installmentoptions',
  //   path: '/installment',
  // },
  {
    name: 'Campaigns',
    url: '/campaign',
    key: 'campaign',
    path: '/campaign',
  },
];

const secondaryNavItems = [
  {
    name: 'Installment Options',
    key: 'installmentoptions',
    submenu: [
      // {
      //   header: 'Kisti',
      //   icon: '/icons/kishti.svg',
      //   subheader: null,
      //   id: 2,
      //   link: '/installment?#kisti',
      // },
      {
        header: '0% EMI',
        icon: '/icons/0_emi.svg',
        subheader: null,
        id: 3,
        link: '/installment#zero-emi',
      },
    ],
  },
  {
    name: 'Brands',
    key: 'brands',
    submenu: [
      {
        type: 'text',
        header: 'Others',
        subheader: [
          {
            name: 'Blueair',
            id: 'blueair',
          },
          {
            name: 'Lenovo',
            id: 'lenovo',
          },
          {
            name: 'Symphony',
            id: 'symphony',
          },
          {
            name: 'Dell',
            id: 'dell',
          },
          {
            name: 'Panasonic',
            id: 'panasonic',
          },
          {
            name: 'Toshiba',
            id: 'toshiba',
          },
          {
            name: 'Galanz',
            id: 'galanz',
          },

          {
            name: 'Phillips',
            id: 'phillips',
          },
          {
            name: 'Unilever',
            id: 'unilever',
          },
          {
            name: 'Haier',
            id: 'haier',
          },
          {
            name: 'Phillips and Havells',
            id: 'phillipsandhavells',
          },
          {
            name: 'V-Guard',
            id: 'vguard',
          },
          {
            name: 'Havells',
            id: 'havells',
          },
          {
            name: 'Preethi',
            id: 'preethi',
          },

          {
            name: 'Videocon',
            id: 'videocon',
          },
          {
            name: 'Hisense',
            id: 'hisense',
          },
          {
            name: 'Samsung',
            id: 'samsung',
          },

          {
            name: 'Vision',
            id: 'vision',
          },
          {
            name: 'HP',
            id: 'hp',
          },
          {
            name: 'Skyworth',
            id: 'skyworth',
          },
          {
            name: 'Whirlpool',
            id: 'whirlpool',
          },
        ],
        id: 1,
      },
    ],
  },
  {
    name: 'Categories',
    key: 'categories',
    submenu: [
      {
        id: 'airConditioners',
        header: 'Air Conditioners',
        icon: '/icons/ac-small.svg',
        subheader: [
          {
            name: 'Non-inverter',
            id: 'noninverter',
          },
          {
            name: 'Inverter',
            id: 'inverter',
          },
          {
            name: 'Semi-commercial',
            id: 'semicommercial',
          },
        ],
      },
      {
        id: 'televisions',
        header: 'Televisions',
        icon: '/icons/tv-small.svg',
        subheader: [
          {
            name: 'QLED',
            id: 'qled',
          },
          {
            name: 'UHD/4k TV',
            id: 'uhd4ktv',
          },
          {
            name: 'Smart TV',
            id: 'smarttv',
          },
          {
            name: 'Basic TV',
            id: 'basictv',
          },
        ],
      },
      {
        id: 'ovens',
        header: 'Ovens',
        icon: '/icons/oven.svg',
        subheader: [
          {
            name: 'Solo',
            id: 'solo',
          },
          {
            name: 'Grill',
            id: 'grill',
          },
          {
            name: 'Convection',
            id: 'convection',
          },
        ],
      },
      {
        id: 'sewingMachines',
        header: 'Sewing Machines',
        icon: '/icons/sewing-machine.svg',
        subheader: null,
      },
      {
        id: 'dishwasher',
        header: 'Dishwasher',
        icon: '/icons/dishwasher.svg',
        subheader: null,
      },
      {
        id: 'kitchenAppliances',
        header: 'Kitchen Appliances',
        icon: '/icons/kitchen.svg',
        subheader: [
          {
            name: 'Blender & Grinder',
            id: 'blenderandgrinder',
          },
          {
            name: 'Rice Cooker',
            id: 'ricecooker',
          },
          {
            name: 'Electric Kettle',
            id: 'electrickettle',
          },
          {
            name: 'Cookwares',
            id: 'cookwares',
          },
          {
            name: 'Coffee Maker',
            id: 'coffeemaker',
          },
          {
            name: 'Chai Maker',
            id: 'chaimaker',
          },
          {
            name: 'Air Fryer',
            id: 'airfryer',
          },
          {
            name: 'Induction Cooker',
            id: 'inductioncooker',
          },
          {
            name: 'Sandwich Maker',
            id: 'sandwichmaker',
          },
          {
            name: 'Water Purifier',
            id: 'waterpurifier',
          },
          {
            name: 'Toaster',
            id: 'toaster',
          },
          {
            name: 'Multi-Cooker',
            id: 'multicooker',
          },
          {
            name: 'Cookware',
            id: 'cookware',
          },
        ],
      },
      {
        id: 'refrigerator',
        header: 'Refrigerators',
        icon: '/icons/refrigerator.svg',
        subheader: [
          {
            name: 'Frost',
            id: 'frost',
          },
          {
            name: 'No Frost',
            id: 'nofrost',
          },
          {
            name: 'Side by Side',
            id: 'sidebyside',
          },
          {
            name: 'Multi-Doors',
            id: 'multidoors',
          },
          {
            name: 'Freezer',
            id: 'freezer',
          },
          {
            name: 'Semi-Commercial',
            id: 'semicommercial',
          },
        ],
      },
      {
        id: 'hood&hobs',
        header: 'Hood & Hobs',
        icon: '/icons/hob.svg',
        subheader: [
          {
            name: 'Gas Burner',
            id: 'gasburner',
          },
          {
            name: 'Induction Cooker',
            id: 'inductioncooker',
          },
          {
            name: 'Kitchen Hood',
            id: 'kitchenhood',
          },
        ],
      },
      {
        id: 'washingMachines',
        header: 'Washing Machines',
        icon: '/icons/washing-machine.svg',
        subheader: [
          {
            name: 'Front Load',
            id: 'frontload',
          },
          {
            name: 'Top Load',
            id: 'topload',
          },
          {
            name: 'Semi-Auto',
            id: 'semiauto',
          },
          {
            name: 'Single Tub',
            id: 'singletub',
          },
        ],
      },
      {
        id: 'computer&accessories',
        header: 'Computers & Accessories',
        icon: '/icons/computer.svg',
        subheader: [
          {
            name: 'Laptop',
            id: 'laptop',
          },
          {
            name: 'Accessories',
            id: 'accessories',
          },
        ],
      },
      {
        id: 'smallAppliances',
        header: 'Small Appliances',
        icon: '/icons/small-appliances.svg',
        subheader: [
          {
            name: 'Personal Care',
            id: 'personalcare',
          },
          {
            name: 'Iron',
            id: 'iron',
          },
          {
            name: 'Vacuum Cleaner',
            id: 'vacuumcleaner',
          },
          {
            name: 'Water Heater',
            id: 'waterheater',
          },
        ],
      },
      {
        id: 'airSolutions',
        header: 'Air Solutions',
        icon: '/icons/air.svg',
        subheader: [
          {
            name: 'Fan',
            id: 'fan',
          },
          {
            name: 'Air Purifier',
            id: 'airpurifier',
          },
          {
            name: 'Room Heater',
            id: 'roomheater',
          },
        ],
      },
      {
        id: 'smartGadgets',
        header: 'Smart Gadgets',
        icon: '/icons/smart-gadget.svg',
        subheader: null,
      },
      {
        id: 'powerSolutions',
        header: 'Power Solutions',
        icon: '/icons/battery.svg',
        subheader: null,
      },
      {
        id: 'spareParts',
        header: 'Spare Parts',
        icon: '/icons/spare-parts.svg',
        subheader: null,
      },
    ],
  },
];

const languageOption = [
  {
    id: 'en',
    name: 'en',
    icon: '/images/flag-usa.png',
  },
  {
    id: 'bn',
    name: 'bn',
    icon: '/images/flag-bd.png',
  },
];

const profileMenuItem = [
  {
    id: 'myAccount',
    name: 'My Profile',
    url: '/my-profile',
  },
  {
    id: 'myOrders',
    name: 'My Orders',
    url: '/my-orders?tab=ongoing',
  },
];

export { primaryNavItems, secondaryNavItems, languageOption, profileMenuItem };
